export { default } from "./version";
